export default __webpack_public_path__ + "static/media/chatBg.56067cf1.png";